import React from "react";
import LegalLayout, { Section, Placeholder } from "./LegalLayout";
import { CONTACT } from "../../mock";

const MentionsLegales = () => {
  return (
    <LegalLayout
      title="Mentions légales"
      subtitle="Informations légales"
      updated="Janvier 2025"
    >
      <p className="text-white/60 mb-8 leading-relaxed">
        Conformément aux dispositions des articles 6-III et 19 de la loi n° 2004-575
        du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), les
        informations suivantes sont portées à la connaissance des utilisateurs du
        site.
      </p>

      <Section title="1. Éditeur du site">
        <p>
          Le présent site est édité par <strong>BS Import Auto</strong>,{" "}
          <Placeholder>[forme juridique : micro-entreprise / EI / SARL – à compléter]</Placeholder>.
        </p>
        <ul>
          <li>Responsable de la publication : <Placeholder>[Nom et prénom – à compléter]</Placeholder></li>
          <li>Siège / adresse : <Placeholder>[adresse complète – à compléter]</Placeholder></li>
          <li>SIRET : <Placeholder>[numéro SIRET – à compléter]</Placeholder></li>
          <li>N° TVA intracommunautaire : <Placeholder>[le cas échéant – à compléter]</Placeholder></li>
          <li>E-mail : <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
          <li>Téléphone : <a href={`tel:${CONTACT.phoneRaw}`}>{CONTACT.phone}</a></li>
        </ul>
      </Section>

      <Section title="2. Hébergement">
        <p>
          Le site est hébergé par <Placeholder>[nom de l'hébergeur – à compléter]</Placeholder>,{" "}
          <Placeholder>[adresse de l'hébergeur – à compléter]</Placeholder>.
        </p>
      </Section>

      <Section title="3. Nature de l'activité">
        <p>
          BS Import Auto propose des prestations de <strong>courtage et
          d'accompagnement à l'importation de véhicules</strong> (recherche,
          négociation, inspection, démarches d'immatriculation) ainsi que des{" "}
          <strong>formations</strong> à l'importation et à l'immatriculation de
          véhicules. BS Import Auto agit en qualité d'<strong>intermédiaire /
          mandataire</strong> et n'est pas le vendeur des véhicules concernés.
        </p>
      </Section>

      <Section title="4. Propriété intellectuelle">
        <p>
          L'ensemble des éléments composant le site (textes, visuels, vidéos,
          logo, charte graphique, structure et contenus) est la propriété
          exclusive de BS Import Auto ou de ses partenaires, et est protégé par le
          droit de la propriété intellectuelle.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication ou
          adaptation, totale ou partielle, de ces éléments, quel que soit le moyen
          ou le procédé utilisé, est interdite sans l'autorisation écrite préalable
          de BS Import Auto. Toute exploitation non autorisée est susceptible de
          constituer une contrefaçon sanctionnée par les articles L.335-2 et
          suivants du Code de la propriété intellectuelle.
        </p>
      </Section>

      <Section title="5. Responsabilité et nature des informations">
        <p>
          Les informations, conseils, estimations et tarifs présentés sur le site
          sont fournis à titre <strong>indicatif</strong> et ne constituent pas un
          engagement contractuel. Chaque prestation fait l'objet d'un devis et/ou
          d'un accord préalable définissant précisément son périmètre et son prix.
        </p>
        <p>
          À titre d'exemple, le forfait de courtage indiqué à 990 € couvre la
          recherche, la négociation, l'inspection et les démarches administratives
          d'immatriculation, mais <strong>n'inclut ni la livraison du véhicule</strong>{" "}
          (proposée en bonus, sur devis), <strong>ni le coût de la carte grise</strong>,
          qui reste à la charge du client.
        </p>
        <p>
          BS Import Auto met tout en œuvre pour assurer l'exactitude des
          informations diffusées mais ne saurait être tenue responsable des
          erreurs, omissions, ni des décisions prises par l'utilisateur sur la base
          de ces informations. La responsabilité de BS Import Auto ne saurait être
          engagée en cas d'indisponibilité temporaire du site ou de dommages
          indirects liés à son utilisation.
        </p>
      </Section>

      <Section title="6. Liens hypertextes">
        <p>
          Le site peut contenir des liens vers des sites tiers. BS Import Auto
          n'exerce aucun contrôle sur ces sites et décline toute responsabilité
          quant à leur contenu.
        </p>
      </Section>

      <Section title="7. Droit applicable et médiation">
        <p>
          Les présentes mentions légales sont régies par le droit français. En cas
          de litige, et à défaut de résolution amiable, les tribunaux français
          seront seuls compétents. Conformément à la réglementation, le
          consommateur peut recourir gratuitement à un médiateur de la consommation :{" "}
          <Placeholder>[coordonnées du médiateur – à compléter]</Placeholder>.
        </p>
      </Section>

      <p className="text-white/40 text-sm mt-10 leading-relaxed">
        Les mentions signalées en orange doivent être complétées avec vos
        informations réelles (statut, adresse, SIRET, hébergeur, médiateur) avant
        la mise en ligne définitive.
      </p>
    </LegalLayout>
  );
};

export default MentionsLegales;
